import { useState, useEffect, useCallback } from 'react';
import { getJobPayments } from '../api/jobPayments';
import type { JobPayment } from '../types/jobPayment';

/**
 * Hook for fetching job payments
 */
export function useJobPayments(jobId: number | undefined, isForecast?: boolean) {
  const [data, setData] = useState<JobPayment[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPayments = useCallback(async () => {
    if (!jobId) {
      setData([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const payments = await getJobPayments(jobId, isForecast);
      setData(payments);
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to fetch job payments');
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [jobId, isForecast]);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchPayments,
  };
}
